import * as React from 'react';
import ChatMessage from '../ChatMessage';
import Avatar from '../../Avatar';
import Flex from '../../Flex';
import ChatContactAction from './predefinedActions/ChatContactAction';
import {GenericTemplateFormatType} from '../../../models/chatChannelModel/message/format';

interface ChatGenericTemplateMessageProps {
  message: ChatMessage<GenericTemplateFormatType>;
}

export default class ChatGenericTemplateMessage extends React.Component<ChatGenericTemplateMessageProps, {}> {
  public render() {
    return (
      <Flex>
        {this.props.message.format.attachment.payload.elements.map(({title, imageUrl, buttons, data}, elemIdx) => (
          <div key={elemIdx} style={{width: '30%'}}>
            <h5>{title}</h5>
            <Avatar src={imageUrl} circle={true} larger={true} />
            <div>
              {buttons.map((btn, btnIdx) => {
                if (btn.kind === 'local') {
                  return btn.action === 'contact_cohost' || btn.action === 'contact_host' ? (
                    <ChatContactAction key={btnIdx} userId={data.get('userId') as number}>
                      {title}
                    </ChatContactAction>
                  ) : null;
                }

                return null;
              })}
            </div>
          </div>
        ))}
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatUI/ChatGenericTemplateMessage/ChatGenericTemplateMessage.tsx